import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CoreModule } from '../../../core/core.module';
import { CoatProductsTableComponent } from './coat-products-table.component';
import {
	MetricImperialInputComponent
} from '../../../components/forms/metric-imperial-input/metric-imperial-input.component';
import { AreaUnitPipe } from '../../../pipes/area.pipe';
import {
	SplitListDropdownComponent
} from '../../../../@mos-core/components/split-list-dropdown/split-list-dropdown.component';
import { LucideAngularModule } from 'lucide-angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonComponent } from '@mos-core/components/button/button.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CdkDrag, CdkDragHandle, CdkDropList } from '@angular/cdk/drag-drop';

@NgModule({
	declarations: [CoatProductsTableComponent],
	imports: [
		CoreModule,
		CommonModule,
		MetricImperialInputComponent,
		AreaUnitPipe,
		SplitListDropdownComponent,
		LucideAngularModule,
		MatTooltipModule,
		ButtonComponent,
		TooltipModule,
		CdkDropList,
		CdkDrag,
		CdkDragHandle,
	],
	exports: [CoatProductsTableComponent],
})
export class CoatProductsTableModule {}
